module.exports = __webpack_public_path__ + "static/img/ku-prime.47a452d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ku-prime.jpg
// module id = NErb
// module chunks = 0